import React, {PureComponent} from 'react';
import axios from 'axios';
import {FuelPricesMapping, IFuelPrice, IPublicFuelPrice, ICustomerFuelPrice} from "./FuelPriceHelper";
import {apiService} from "../../services/api.service";
import {AuthenticationContext} from "../../services/context/authentication.context";
import { getPriceWithoutVAT } from 'helpers';
import {SwitchButton, SwitchButtonState} from "../SwitchButton/SwitchButton";
import { Spinner } from 'react-bootstrap';
import moment from 'moment';

interface IFuelPriceState {
    customerId: number | null;
    customerTimeUpdated?: number;
    prices: Array<IFuelPrice>;
    publicPrices: Array<IPublicFuelPrice>;
    publicPricesLoading: boolean;
    customerPrices: Array<ICustomerFuelPrice>;
    customerPricesLoading: boolean;
    showWithVAT: boolean;
}

export class FuelPrices extends PureComponent<any, IFuelPriceState> {
    static contextType = AuthenticationContext;
    constructor(props: any) {
        super(props);
        this.state = {
            customerId: null,
            customerTimeUpdated: undefined,
            prices: [...FuelPricesMapping],
            customerPricesLoading: false,
            publicPricesLoading: false,
            publicPrices: [],
            customerPrices: [],
            showWithVAT: true,
        };

    }

    onVatSwitchChange = (active: SwitchButtonState) => {
        this.setState({
            showWithVAT: active === SwitchButtonState.LEFT ? true : false
        });
    };

    getCustomerPrices = (customerId: number) => {
        const apiUrl = apiService.getApiUrl();
        return axios.get(apiUrl + '/product-customer-price/' + customerId);
    };

    getPublicFuelPrices = () => {
        const apiUrl = apiService.getBaseUrl();
        return axios.get(apiUrl + '/v1/prices');
    };


    componentDidMount(): void {
        this.setState({
            customerId: this.context.state.customerId
        }, () => this.getAllPrices());
    }

    componentDidUpdate(): void {
        if (!this.state.customerId || this.context.state.customerId !== this.state.customerId || this.state.customerTimeUpdated !== this.context.state.customer?.timeUpdated) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
                customerTimeUpdated: this.context.state.customer?.timeUpdated
            }, () => {
                if (this.context.state.customerId) {
                    this.getAllPrices();
                }
            });
        }
    }

    getAllPrices = () => {
        this.setState({ publicPricesLoading: true });
        this.getPublicFuelPrices().then(response => {
            if (response.status === 200) {
                const publicPrices: Array<IPublicFuelPrice> = response.data;
                const newPrices: Array<IFuelPrice> = [];
                for (const publicPrice of publicPrices) {
                    const matching = this.state.prices.find(price => price.noomId === publicPrice.noomId);
                    if (matching) {
                        const newPrice = {
                            ...matching,
                            priceOnLocation: publicPrice.price
                        }
                        newPrices.push(newPrice)
                    }
                }
                this.setState({publicPrices: publicPrices, prices: newPrices}, () => {
                    if (this.context.state.customerId === null) {
                        return;
                    }
                    this.setState({ customerPricesLoading: true });
                    this.getCustomerPrices(this.context.state.customerId)
                        .then((customerResponse) => {
                            if (customerResponse.status === 200) {
                                const customerPrices: Array<ICustomerFuelPrice> = customerResponse.data.data;
                                const newPrices: Array<IFuelPrice> = [];
                                if (customerPrices.length > 0) {
                                    for (const customerPrice of customerPrices) {
                                        const matching = this.state.prices.find(price => price.noomId === customerPrice.noomId);
                                        if (matching) {
                                            const newPrice = Object.assign({}, matching);
                                            newPrice.withVAT = customerPrice.clientPrice;
                                            newPrice.withoutVAT = getPriceWithoutVAT(Number(customerPrice.clientPrice), moment()) + '';
                                            newPrice.fixedPrice = customerPrice.fixedPrice;
                                            newPrices.push(newPrice);
                                        }
                                    }
                                    this.setState({customerPrices: customerPrices, prices: newPrices});
                                }
                            }

                        }).catch((error: any) => console.error(error.message)).finally(() => this.setState({ customerPricesLoading: false }))
                });
            }
        }).catch((error: any) => {
            console.error(error.message);
        }).finally(() => this.setState({ publicPricesLoading: false }));

    }
    render() {
        if (!this.context.state.customer) {
            return null;
        }
        const fuelPrices = this.state.prices
            .filter(p => p.businessOnly ? !this.context.state.customer.isPerson : true)
            .sort((a, b) => ((a.sortOrder < b.sortOrder) ? -1 : ((a.sortOrder > b.sortOrder) ? 1 : 0)))
            .map((item: IFuelPrice) => {
                const customerPrice = Number(this.state.showWithVAT ? item.withVAT : item.withoutVAT);
                return (
                    <React.Fragment key={item.type}>
                        <tr>
                            <td className='fuelprices-type'>
                                <span className='px-2 py-1 rounded text-center d-inline-block' style={{ backgroundColor: item.colorCode, color: item.textColor }}>
                                    {item.type}
                                </span>
                            </td>
                            <td className='fuelprices-value'>
                                <span className="d-inline-block font-weight-bold bg-gray-300 text-gray-700 px-2 py-1 rounded">{
                                    this.state.publicPricesLoading ?
                                        <Spinner animation={"border"} size={"sm"} /> :
                                        item.fixedPrice ?
                                        <>{ parseFloat(Number(customerPrice).toFixed(3)) } {item.unitFixed}</> :
                                        <>{ parseFloat(Number(customerPrice * 100).toFixed(3)) } {item.unit}</>
                                    }
                                </span>
                            </td>
                        </tr>
                    </React.Fragment>
                )
            });

        return (
            <div className="fuel-prices__container">
                <div className='d-flex justify-content-between align-items-center'>
                    <strong>Tabelis on toodud Terminali kliendile kehtiv hind või tootele kehtiv soodustus postihinnast.<br />Postihinnad võivad asukohtade lõikes erineda.</strong>
                    <SwitchButton
                        className={"ml-auto"}
                        active={SwitchButtonState.LEFT}
                        onActiveChange={this.onVatSwitchChange}
                        labelLeft={"KM-ga"}
                        labelRight={"KM-ta"}
                    />
                </div>
                <table className='fuel-prices__table table table-borderless'>
                    <thead>
                    <tr>
                        <th className='text-center text-wrap fuelprices-type'>Kütus</th>
                        <th className='text-center text-wrap fuelprices-value'>
                            Kliendi soodustus/hind
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        {fuelPrices}
                    </tbody>
                </table>
            </div>
        );
    }
}